import MaterialSlider, { SliderProps } from '@mui/material/Slider';

export function Slider(props: SliderProps) {
    return <MaterialSlider data-testid={'Slider-container'} {...props} />;
}

export default Slider;
